module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/037-jamaica-da899ae96b2da76ae75caca1029e3611.svg";